import { FC } from 'react';
import { StatusEffect } from '../../data/abilities';

interface StatusEffectOverlayProps {
  effects: StatusEffect[];
}

const StatusEffectOverlay: FC<StatusEffectOverlayProps> = ({ effects }) => {
  const getEffectAnimations = () => {
    const animations: string[] = [];
    
    effects.forEach(effect => {
      switch (effect.type) {
        case 'burn':
          animations.push('animate-burn-effect');
          break;
        case 'freeze':
          animations.push('animate-freeze-effect');
          break;
        case 'stun':
          animations.push('animate-stun-effect');
          break;
      }
    });

    return animations.join(' ');
  };

  if (effects.length === 0) return null;

  return (
    <div
      className={`absolute inset-0 pointer-events-none ${getEffectAnimations()}`}
    >
      {effects.map((effect, index) => (
        <div key={index} className="absolute inset-0">
          {effect.type === 'burn' && (
            <div className="absolute inset-0 bg-gradient-to-t from-red-500/20 to-transparent" />
          )}
          {effect.type === 'freeze' && (
            <div className="absolute inset-0 bg-gradient-to-t from-blue-500/20 to-transparent" />
          )}
          {effect.type === 'stun' && (
            <div className="absolute inset-0">
              <div className="absolute top-0 left-1/2 -translate-x-1/2 text-yellow-500 text-4xl">
                ⚡
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default StatusEffectOverlay; 